export default {"src":"/_next/static/media/pubgenLogo_light.5514bb24.svg","height":52,"width":286,"blurWidth":0,"blurHeight":0};